import React from 'react';
import { Link } from 'react-router-dom';
import BraceletLedLogo from './BraceletLedLogo';

const Logo = ({ className = "" }) => {
  return (
    <Link to="/" className={`flex items-center space-x-3 ${className}`}>
      <BraceletLedLogo size={50} />
      <div className="flex flex-col leading-tight">
        <span className="text-white font-bold text-sm tracking-wide">PARTY-LED.COM</span>
        <span className="text-orange-400 font-medium text-[10px] tracking-wider">Bracelets LED Contrôlés</span>
      </div>
    </Link>
  );
};

export default Logo;
